<template>
	<div class="modal-card upload-model">
		<header class="modal-card-head has-background-white">
			<h3 class="modal-card-title has-text-centered" v-if="user_id != -1">
				Editar relación del usuario con la empresa
			</h3>
			<h3 class="modal-card-title has-text-centered" v-else>
				Añadir un usuario
			</h3>
			<button class="delete" aria-label="Cerrar Modal" @click="$emit('close')"></button>
		</header>
		<section class="section_analysts">
			<div v-if="user_id != -1" role="navigation" aria-label="main navigation" class="analyst_users">
				<div class="selected_user">
					{{ user_email }}
				</div>
			</div>
			<table v-else>
				<tr>
					<td class="filtrar_text">Filtrar usuarios:</td>
					<td><input type="text" v-model="filterUsers" placeholder="Nombre, RUT o email" /></td>
				</tr>
			</table>
		</section>
		<section class="section_companies">
			<div class="companies">
				<table class="table_companies">
					<tr v-for="company in companies_list" v-bind:key="company.id" class="company_row"
						:class="{ selected_row: company.selected }" @click="selectRow(company)">
						<td class="check_td">
							<button :class="[
								'first_button',
								{ unselected_button: !company.selected },
								{ selected_button: company.selected }]"
								aria-label="Seleccionar empresa">
								{{ company.selected ? "✔" : "" }}
							</button>
						</td>
						<td class="company_td" v-if="user_id == -1">
							<div class="nobreak">
								{{ company.email }}
							</div>
						</td>
						<td class="company_td" v-else>
							<div class="nobreak">
								{{ company.rut }}
							</div>
						</td>
						<td class="company_td">
							<div>
								{{ company.name }}
							</div>
						</td>
						<td class="company_td role_td" v-if="user_id != -1" @click.stop>
							<select v-model="company.role" class="role_select"
								aria-label="Rol del usuario en la empresa">
								<option value="">Sin rol</option>
								<option v-for="option in roleOptions" :key="option.value"
									:value="option.value">
									{{ option.label }}
								</option>
							</select>
						</td>
					</tr>
				</table>
			</div>
		</section>
		<footer class="modal-card-foot bt-none has-background-white is-justify-content-flex-end">
			<button class="button" @click="$emit('close')" aria-label="Cerrar Modal" role="button">
				Volver
			</button>
			<button class="button is-primary" :disabled="loading" role="button" @click="grabarEmpresasAnalista()">
				Grabar
			</button>
		</footer>
	</div>
</template>

<script>
import { companies_per_user, save_analysts_per_company, save_companies_analyst, users_of_company } from "@/api/carteraAnalista";
import { consoleHandlerError, notificate } from "@/utils/message";
import { ROLE_OPTIONS } from "@/utils/roles";

export default {
	name: "AssignUsers",
	data() {
		return {
			companies_list: [],
			raw_analistas: [],
			filterUsers: "",
			loading: false,
			roleOptions: ROLE_OPTIONS,
		};
	},
	props: {
		user_id: {
			type: Number,
			required: true,
		},
		company_id: {
			type: Number,
			required: true,
		},
		user_email: {
			type: String,
			required: true,
		},
	},
	components: {
	},
	computed: {
	},
	methods: {
		filterData() {
			if (this.filterUsers == "") {
				this.companies_list = this.raw_analistas;
			} else {
				const normalized_filter = this.filterUsers.replace(/\s+/g, "").toUpperCase();
				const filtered_analistas = this.raw_analistas.filter(
					(user) => {
						const normalized_text = user['all_text'].replace(/\s+/g, "").toUpperCase();
						return normalized_text.includes(normalized_filter);
					}
				);
				this.companies_list = filtered_analistas;
			}
		},
		selectRow(company) {
			company['selected'] = !company['selected'];
		},
		async grabarEmpresasAnalista() {
			if (this.user_id != -1) {
				this.loading = true;
				save_companies_analyst(this.user_id, this.companies_list).then(
					() => {
						notificate(
							"Se grabaron las compañias del usuario.",
							"is-success is-light",
							"is-top-right",
							false,
							5000
						);
						this.loading = false;
					}
				).catch(() => {
					this.loading = false;
					consoleHandlerError('Error al grabar las compañias del usuario.');
				}).finally(() => {
					this.$emit("close");
				})
			} else {
				this.loading = true;
				save_analysts_per_company(this.company_id, this.companies_list).then(
					() => {
						notificate(
							"Se grabaron los usuarios de la compañia.",
							"is-success is-light",
							"is-top-right",
							false,
							5000
						);
						this.loading = false;
					}
				).catch(() => {
					this.loading = false;
					consoleHandlerError('Error al grabar los usuarios de la compañia.');
				}).finally(() => {
					this.$emit("close");
				});
			}
		},
	},
	mounted() {
		if (this.user_id == -1) {
			users_of_company(this.company_id).then((response) => {
				this.raw_analistas = response.data['companies'];
				this.companies_list = this.raw_analistas;
			}).catch(() => {
				consoleHandlerError('Error al recuperar los usuarios de la compañia.');
			});
		} else {
			companies_per_user(this.user_id).then((response) => {
				// Garantizamos la key `role` upfront: v-model sobre company.role
				// necesita que exista para ser reactivo en Vue 2 (sin $set).
				const companies = response.data['companies'].map(
					(company) => ({ ...company, role: company.role || "" })
				);
				this.raw_analistas = companies;
				this.companies_list = companies;
			}).catch(() => {
				consoleHandlerError('Error al recuperar las compañias del usuario.');
			});
		}
	},
	watch: {
		filterUsers() {
			this.filterData();
		}
	},
};
</script>
<style scoped lang="scss">
// Tema del analista (var(--ap-*), elements/_analyst_theme.scss).
.upload-model {
	font-family: var(--ap-font);
	color: var(--ap-ink-2);
	background-color: var(--ap-paper);
	border-radius: var(--ap-radius);
	overflow: hidden;
	width: min(720px, 94vw);
	display: flex;
	flex-direction: column;
	max-height: 86vh;
}

.modal-card-head {
	border-bottom: 1px solid var(--ap-line);
}

:deep(.modal-card-title){
	font-family: var(--ap-font);
	font-weight: 700;
	font-size: 20px;
	letter-spacing: -0.01em;
	color: var(--ap-ink);
}

// Encabezado del cuerpo: usuario seleccionado (edición) o filtro de usuarios.
.section_analysts {
	padding: 16px 22px;
	background-color: var(--ap-paper);
	border-bottom: 1px solid var(--ap-line);
	display: flex;
	justify-content: center;
	align-items: center;

	table,
	tr,
	td {
		border: none;
	}
}

.analyst_users {
	display: flex;
	justify-content: center;
	align-items: center;
}

.selected_user {
	font-weight: 700;
	font-size: 15px;
	color: var(--ap-ink);
}

.filtrar_text {
	padding-right: 12px;
	font-size: 11px;
	font-weight: 600;
	letter-spacing: 0.08em;
	text-transform: uppercase;
	color: var(--ap-muted);
	white-space: nowrap;
}

.section_analysts input {
	min-width: 260px;
	padding: 8px 12px;
	border: 1px solid var(--ap-line-strong);
	border-radius: var(--ap-radius-sm);
	font-family: var(--ap-font);
	font-size: 13.5px;
	color: var(--ap-ink);
	transition: border-color 0.14s var(--ap-ease), box-shadow 0.14s var(--ap-ease);

	&:focus {
		outline: none;
		border-color: var(--ap-teal);
		box-shadow: 0 0 0 3px var(--ap-teal-wash);
	}
}

// Listado de empresas
.section_companies {
	flex: 1;
	background-color: var(--ap-paper);
	overflow: hidden auto;
	padding: 16px 22px 22px;
}

.companies {
	display: flex;
	justify-content: center;
	width: 100%;
}

.table_companies {
	width: 100%;
	border-collapse: collapse;
}

.company_row {
	cursor: pointer;
	background-color: var(--ap-paper);
	transition: background-color 0.14s var(--ap-ease);

	&:hover {
		background-color: var(--ap-mist);
	}

	&:focus-visible {
		outline: 2px solid var(--ap-teal);
		outline-offset: -2px;
	}
}

.selected_row {
	background-color: var(--ap-teal-wash);
}

.company_td {
	vertical-align: middle;
	padding: 10px 8px;
	border-bottom: 1px solid var(--ap-line);
	font-size: 13.5px;
	color: var(--ap-ink);
	text-align: left;
}

.check_td {
	padding: 10px 8px;
	border-bottom: 1px solid var(--ap-line);
	width: 52px;
	text-align: center;
}

.role_td {
	text-align: right;
}

.nobreak {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	font-weight: 600;
}

// Botón-casilla de selección: teal cuando la empresa está elegida.
.first_button {
	width: 34px;
	height: 34px;
	border-radius: var(--ap-radius-sm);
	cursor: pointer;
	font-weight: 700;
	transition: background-color 0.14s var(--ap-ease), border-color 0.14s var(--ap-ease),
		transform 0.14s var(--ap-ease);

	&:focus-visible {
		outline: 2px solid var(--ap-teal);
		outline-offset: 2px;
	}
}

.unselected_button {
	background-color: var(--ap-mist);
	border: 1px solid var(--ap-line-strong);
	color: transparent;
}

.selected_button {
	background-color: var(--ap-teal);
	border: 1px solid var(--ap-teal);
	color: #fff;
}

// Selector de rol
.role_select {
	padding: 6px 10px;
	border: 1px solid var(--ap-line-strong);
	border-radius: var(--ap-radius-sm);
	background-color: var(--ap-paper);
	font-family: var(--ap-font);
	font-size: 13px;
	color: var(--ap-ink);
	transition: border-color 0.14s var(--ap-ease), box-shadow 0.14s var(--ap-ease);

	&:focus {
		outline: none;
		border-color: var(--ap-teal);
		box-shadow: 0 0 0 3px var(--ap-teal-wash);
	}
}

// Footer
:deep(.modal-card-foot){
	border-top: 1px solid var(--ap-line);

	.button.is-primary {
		background-color: var(--ap-ink);
		border-color: transparent;
		font-weight: 600;

		&:hover {
			background-color: var(--ap-teal-deep);
		}
	}
}
</style>
